// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__sEgTO","upload":"Small_upload__3qPR7","imageWrap":"Small_imageWrap__UjnW1","removeBtn":"Small_removeBtn__2iSx4"};